<template>
  <el-container class="login" style="display: table-cell" v-title data-title="扫码签到">
    <el-col :span="24" style="text-align: center; line-height: 3rem; font-size: 1.3rem;">
      请用微信刷二维码签到（未绑定【佳效安防」公众号请先绑定）
    </el-col>
    <el-col :span="24" style="text-align: center; line-height: 5rem; font-size: 2rem; font-weight: bold; color: red">
      签到地点：{{ spot }}
    </el-col>
    <el-col v-show="showQr" :span="24" style="text-align: center">
      <img width=180 style="margin-top: -4px" :src="qrCode" />
    </el-col>
  </el-container>
</template>

<script>
export default ({
  data () {
    return {
      loginForm: {
        userName: '',
        password: '',
        userType: '2'
      },
      // qrState: '',
      qrCode: '',
      showQr: true,
      timer: null,
      websock: null,
      schoolId: null,
      spot: null
    }
  },
  mounted () {
    let schoolIdArr = /schoolId=([^&#]+)/.exec(window.location.href)
    let spotArr = /spot=([^&#]+)/.exec(window.location.href)
    if (schoolIdArr !== null && schoolIdArr[1] != null) {
      this.schoolId = schoolIdArr[1]
    }
    if (spotArr !== null && spotArr[1] != null) {
      this.spot = decodeURI(spotArr[1])
    }
    console.log(this.schoolId)
    console.log(this.spot)
    if (this.schoolId != null && this.spot != null) {
      // this.getQrLoginCode()
      this.initWebSocket()
    }
    // this.getTime()
    // this.getQrLoginCode()
  },
  created () {
    // this.initWebSocket()
  },
  destroyed () {
    // if (this.timer) {
    //   clearInterval(this.timer)
    // }
    this.websock.close()
  },
  methods: {
    getTime () {
      this.$axios.get(this.GLOBAL.host + '/time').then(res => {
        if (res.data && res.data.status === 200 && res.data.data) {
          this.Cookie.set('offsetSecond', parseInt(res.data.data) - Math.round(new Date().getTime() / 1000))
        }
      })
    },
    initWebSocket () {
      // 初始化weosocket
      this.websock = new WebSocket(this.GLOBAL.wsHost)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen () {
      // 连接建立之后执行send方法发送数据
      this.websocketsend('getFacultyScanAttendanceQr_' + this.schoolId + '_' + this.spot)
    },
    websocketonerror () {
      // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage (e) {
      // 数据接收
      console.log('receive message: ' + e.data)
      if (e.data != null) {
        if (e.data.substring(0, 32) === 'sendFacultyScanAttendanceQrCode_') {
          let message = JSON.parse(e.data.substring(32))
          if (message != null && message.qrState != null && message.qrCode != null) {
            // this.qrState = message.qrState
            this.qrCode = message.qrCode
          }
        } else if (e.data.substring(0, 31) === 'facultyScanAttendanceQrSuccess_') {
          this.$message.success(e.data.substring(31))
          this.websocketsend('getFacultyScanAttendanceQr_' + this.schoolId + '_' + this.spot)
        }
      }
    },
    websocketsend (Data) {
      // 数据发送
      this.websock.send(Data)
    },
    websocketclose (e) {
      // 关闭
      console.log('断开连接', e)
    }
  }
})
</script>
<style>
html, body, #app {
  height: 100%;
}
#app {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FacultyScanAttendance.vue